<template>
  <div class="w-full h-[600px] relative" id="hero">
    <NuxtImg
      format="webp"
      :src="hero.src"
      :alt="title"
      class="w-full h-full max-h-screen inset-0 object-cover object-center -z-1"
    >
    </NuxtImg>
    <div
      class="absolute inset-0 z-0 bg-gradient-to-r from-[--start] via-70% via-transparent to-[#00000099]"
      :style="{
        '--start': hero.bgColor ?? 'black',
      }"
    >
      <div
        class="container mx-auto flex flex-col h-full min-h-[inherit] justify-center"
      >
        <div
          class="rounded-full bg-white text-black px-3 text-sm md:text-base mx-auto md:mx-0 w-fit"
          v-html="hero.banner"
        ></div>
        <div class="w-full md:w-1/2">
          <h1
            class="text-white text-header-xl pt-4 text-center md:text-start whitespace-pre-line"
          >
            <span
              v-for="item in hero.title"
              :class="
                item.isFancy
                  ? 'primary-gradient bg-clip-text text-transparent'
                  : ''
              "
            >
              {{ item.text }}
            </span>
          </h1>
          <h2 class="text-white text-sm pt-6">
            {{ hero.subtitle }}
          </h2>
          
          <!-- Updated button section to handle external links -->
          <a
            v-if="hero.buttonLink"
            :href="hero.buttonLink"
            target="_blank"
            rel="noopener noreferrer"
            :aria-label="hero.buttonText"
            class="bg-gradient-to-r from-primary to-primary-dark mt-4 rounded-md flex gap-2 mx-auto md:mx-0 w-fit px-4 py-2 text-white font-semibold hover:opacity-90 transition-opacity"
          >
            {{ hero.buttonText }}
            <Icon icon="mdi-arrow-right" class="text-lg"></Icon>
          </a>
          
          <Button
            v-else
            :aria-label="hero.buttonText"
            class="bg-gradient-to-r from-primary to-primary-dark mt-4 rounded-md flex gap-2 mx-auto md:mx-0"
            @click="openContactModal"
          >
            {{ hero.buttonText }}
            <Icon icon="mdi-arrow-right" class="text-lg"></Icon>
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Icon } from "@iconify/vue";
import { useModal } from "vue-final-modal";
import ContactModal from "~/components/global/ContactModal.vue";

defineProps({
  title: {
    type: String,
    required: true,
  },
  hero: {
    type: Object,
    required: true,
  },
});

const openContactModal = async () => {
  const modal = useModal({
    component: ContactModal,
  });

  await modal.open();
};
</script>

<style scoped></style>
